<!-- Center canvas: summary, text typed into directly - whole card is one pinnable region -->
<div class="cr-onp-card" *ngIf="isPreview" [id]="block.blockId">
  <span class="cr-onp-badge">2x Property Recommendation Old/New Price</span>

  <div class="cr-onp-grid">
    <div class="cr-onp-item">
      <div
        class="cr-onp-dropzone"
        [appInlineMedia]="block.variables?.['X2Onp1Image']"
        [inlineMediaBlockId]="block.blockId"
        (inlineMediaChange)="onChange($event, 'X2Onp1Image')"
      >
        <a *ngIf="block.variables?.['X2Onp1Image']; else empty1" [href]="card1ImageHref" target="_blank" rel="noopener">
          <img [src]="block.variables?.['X2Onp1Image']" [alt]="block.variables?.['X2Onp1ImageAlt'] || ''" />
        </a>

        <ng-template #empty1>
          <div class="cr-inline-media-icon">
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
              <path d="M12 19.2V11.7" />
              <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
            </svg>
          </div>
          <div class="cr-inline-media-title">Upload image</div>
          <div class="cr-inline-media-subtitle">PNG up to 2 mb</div>
        </ng-template>
      </div>

      <span
        class="cr-onp-name"
        [appInlineEdit]="block.variables?.X2Onp1Name ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert property name"
        (inlineEditChange)="onChange($event, 'X2Onp1Name')"
      ></span>

      <div class="cr-onp-price-offer">
        <span class="cr-onp-price-copy">Per day/<br />starting from</span>
        <span class="cr-onp-price-row">
          <span class="cr-onp-old-price" *ngIf="block.variables?.X2Onp1OldPrice" [innerHTML]="block.variables?.X2Onp1OldPrice"></span>
          <span
            class="cr-onp-new-price"
            [appInlineEdit]="block.variables?.X2Onp1NewPrice ?? ''"
            [inlineEditBlockId]="block.blockId"
            inlineEditPlaceholder="New price"
            (inlineEditChange)="onChange($event, 'X2Onp1NewPrice')"
          ></span>
        </span>
      </div>

      <a class="cr-onp-cta" [href]="card1CtaHref" target="_blank" rel="noopener">
        <span
          [appInlineEdit]="block.variables?.X2Onp1CtaText ?? ''"
          [inlineEditBlockId]="block.blockId"
          [inlineEditPlaceholder]="ctaButtonPlaceholder"
          (inlineEditChange)="onChange($event, 'X2Onp1CtaText')"
        ></span>
      </a>
    </div>

    <div class="cr-onp-item">
      <div
        class="cr-onp-dropzone"
        [appInlineMedia]="block.variables?.['X2Onp2Image']"
        [inlineMediaBlockId]="block.blockId"
        (inlineMediaChange)="onChange($event, 'X2Onp2Image')"
      >
        <a *ngIf="block.variables?.['X2Onp2Image']; else empty2" [href]="card2ImageHref" target="_blank" rel="noopener">
          <img [src]="block.variables?.['X2Onp2Image']" [alt]="block.variables?.['X2Onp2ImageAlt'] || ''" />
        </a>

        <ng-template #empty2>
          <div class="cr-inline-media-icon">
            <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
              <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
              <path d="M12 19.2V11.7" />
              <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
            </svg>
          </div>
          <div class="cr-inline-media-title">Upload image</div>
          <div class="cr-inline-media-subtitle">PNG up to 2 mb</div>
        </ng-template>
      </div>

      <span
        class="cr-onp-name"
        [appInlineEdit]="block.variables?.X2Onp2Name ?? ''"
        [inlineEditBlockId]="block.blockId"
        inlineEditPlaceholder="Insert property name"
        (inlineEditChange)="onChange($event, 'X2Onp2Name')"
      ></span>

      <div class="cr-onp-price-offer">
        <span class="cr-onp-price-copy">Per day/<br />starting from</span>
        <span class="cr-onp-price-row">
          <span class="cr-onp-old-price" *ngIf="block.variables?.X2Onp2OldPrice" [innerHTML]="block.variables?.X2Onp2OldPrice"></span>
          <span
            class="cr-onp-new-price"
            [appInlineEdit]="block.variables?.X2Onp2NewPrice ?? ''"
            [inlineEditBlockId]="block.blockId"
            inlineEditPlaceholder="New price"
            (inlineEditChange)="onChange($event, 'X2Onp2NewPrice')"
          ></span>
        </span>
      </div>

      <a class="cr-onp-cta" [href]="card2CtaHref" target="_blank" rel="noopener">
        <span
          [appInlineEdit]="block.variables?.X2Onp2CtaText ?? ''"
          [inlineEditBlockId]="block.blockId"
          [inlineEditPlaceholder]="ctaButtonPlaceholder"
          (inlineEditChange)="onChange($event, 'X2Onp2CtaText')"
        ></span>
      </a>
    </div>
  </div>
</div>

<!-- Right panel: real edit form - two identical field groups, one per card -->
<div class="cr-onp-edit" *ngIf="!isPreview">
  <div class="cr-onp-edit-card">
    <div class="cr-onp-edit-card-title">Property 1</div>

    <div class="cr-onp-field-row">
      <span class="cr-onp-field-label">Image</span>
      <span
        class="cr-onp-toggle"
        [class.cr-onp-toggle-on]="image1AsUpload"
        role="button"
        tabindex="0"
        [title]="image1AsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
        (click)="toggleImage1Mode()"
        (keydown.enter)="toggleImage1Mode()"
        (keydown.space)="toggleImage1Mode()"
      ></span>
    </div>
    <div class="cr-onp-image-field">
      <app-block-text
        [maxLength]="500"
        type="link"
        [blockData]="block.variables?.['X2Onp1Image'] ?? ''"
        (handleOnChange)="onChange($event, 'X2Onp1Image')"
        [placeholder]="image1Placeholder"
        variable="X2Onp1Image"
        [isImage]="image1AsUpload"
        [isPlainText]="true"
        [blockId]="block.blockId"
      ></app-block-text>
      <div class="cr-onp-empty-overlay" *ngIf="image1AsUpload && !block.variables?.['X2Onp1Image']">
        <div class="cr-onp-icon">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
            <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
            <path d="M12 19.2V11.7" />
            <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
          </svg>
        </div>
        <div class="cr-onp-title">Upload image</div>
        <div class="cr-onp-subtitle">PNG up to 2 mb</div>
      </div>
    </div>

    <div class="cr-onp-link-field">
      <app-field-editor-v2
        [maxLength]="500"
        type="action-link"
        [blockData]="block.variables?.['X2Onp1ImageHref'] ?? ''"
        (handleOnChange)="onChange($event, 'X2Onp1ImageHref')"
        [placeholder]="image1HrefPlaceholder"
        variable="X2Onp1ImageHref"
        (handleOnSegmentChange)="handleOnSegmentChange($event, 'X2Onp1ImageHrefSegmentRegex')"
        [selectedSegment]="block.variables?.['X2Onp1ImageHrefSegmentRegex'] ?? ''"
        [disabled]="disabled"
      ></app-field-editor-v2>
    </div>

    <app-field-editor-v2
      type="alt"
      [blockData]="block.variables?.['X2Onp1ImageAlt'] ?? ''"
      (handleOnChange)="onChange($event, 'X2Onp1ImageAlt')"
      [placeholder]="image1AltPlaceholder"
      [maxLength]="500"
      variable="X2Onp1ImageAlt"
      [disabled]="disabled"
    ></app-field-editor-v2>

    <app-field-editor-v2
      type="content"
      [blockData]="block.variables?.['X2Onp1Name'] ?? ''"
      (handleOnChange)="onChange($event, 'X2Onp1Name')"
      [placeholder]="name1Placeholder"
      [maxLength]="500"
      variable="X2Onp1Name"
      [disabled]="disabled"
    ></app-field-editor-v2>

    <div class="cr-onp-price-fields">
      <app-field-editor-v2
        type="content"
        [blockData]="block.variables?.['X2Onp1OldPrice'] ?? ''"
        (handleOnChange)="onChange($event, 'X2Onp1OldPrice')"
        [placeholder]="oldPrice1Placeholder"
        [maxLength]="25"
        variable="X2Onp1OldPrice"
        [disabled]="disabled"
      ></app-field-editor-v2>

      <app-field-editor-v2
        type="content"
        [blockData]="block.variables?.['X2Onp1NewPrice'] ?? ''"
        (handleOnChange)="onChange($event, 'X2Onp1NewPrice')"
        [placeholder]="newPrice1Placeholder"
        [maxLength]="25"
        variable="X2Onp1NewPrice"
        [disabled]="disabled"
      ></app-field-editor-v2>
    </div>

    <div class="cr-onp-link-field">
      <app-field-editor-v2
        type="action-link"
        [blockData]="block.variables?.['X2Onp1CtaLink'] ?? ''"
        (handleOnChange)="onChange($event, 'X2Onp1CtaLink')"
        [placeholder]="ctaLink1Placeholder"
        [maxLength]="500"
        variable="X2Onp1CtaLink"
        (handleOnSegmentChange)="handleOnSegmentChange($event, 'X2Onp1CtaLinkSegmentRegex')"
        [selectedSegment]="block.variables?.['X2Onp1CtaLinkSegmentRegex'] ?? ''"
        [disabled]="disabled"
      ></app-field-editor-v2>
    </div>

    <app-field-editor-v2
      type="content"
      [blockData]="block.variables?.['X2Onp1CtaText'] ?? ''"
      (handleOnChange)="onChange($event, 'X2Onp1CtaText')"
      [placeholder]="ctaText1Placeholder"
      [maxLength]="30"
      variable="X2Onp1CtaText"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>

  <div class="cr-onp-edit-card">
    <div class="cr-onp-edit-card-title">Property 2</div>

    <div class="cr-onp-field-row">
      <span class="cr-onp-field-label">Image</span>
      <span
        class="cr-onp-toggle"
        [class.cr-onp-toggle-on]="image2AsUpload"
        role="button"
        tabindex="0"
        [title]="image2AsUpload ? 'Switch to entering an image link' : 'Switch to uploading an image'"
        (click)="toggleImage2Mode()"
        (keydown.enter)="toggleImage2Mode()"
        (keydown.space)="toggleImage2Mode()"
      ></span>
    </div>
    <div class="cr-onp-image-field">
      <app-block-text
        [maxLength]="500"
        type="link"
        [blockData]="block.variables?.['X2Onp2Image'] ?? ''"
        (handleOnChange)="onChange($event, 'X2Onp2Image')"
        [placeholder]="image2Placeholder"
        variable="X2Onp2Image"
        [isImage]="image2AsUpload"
        [isPlainText]="true"
        [blockId]="block.blockId"
      ></app-block-text>
      <div class="cr-onp-empty-overlay" *ngIf="image2AsUpload && !block.variables?.['X2Onp2Image']">
        <div class="cr-onp-icon">
          <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">
            <path d="M7.4 18.3H6.2a4.2 4.2 0 0 1-.45-8.38A6.25 6.25 0 0 1 17.83 8.7a4.85 4.85 0 0 1 .02 9.6H16.6" />
            <path d="M12 19.2V11.7" />
            <path d="m8.9 14.8 3.1-3.1 3.1 3.1" />
          </svg>
        </div>
        <div class="cr-onp-title">Upload image</div>
        <div class="cr-onp-subtitle">PNG up to 2 mb</div>
      </div>
    </div>

    <div class="cr-onp-link-field">
      <app-field-editor-v2
        [maxLength]="500"
        type="action-link"
        [blockData]="block.variables?.['X2Onp2ImageHref'] ?? ''"
        (handleOnChange)="onChange($event, 'X2Onp2ImageHref')"
        [placeholder]="image2HrefPlaceholder"
        variable="X2Onp2ImageHref"
        (handleOnSegmentChange)="handleOnSegmentChange($event, 'X2Onp2ImageHrefSegmentRegex')"
        [selectedSegment]="block.variables?.['X2Onp2ImageHrefSegmentRegex'] ?? ''"
        [disabled]="disabled"
      ></app-field-editor-v2>
    </div>

    <app-field-editor-v2
      type="alt"
      [blockData]="block.variables?.['X2Onp2ImageAlt'] ?? ''"
      (handleOnChange)="onChange($event, 'X2Onp2ImageAlt')"
      [placeholder]="image2AltPlaceholder"
      [maxLength]="500"
      variable="X2Onp2ImageAlt"
      [disabled]="disabled"
    ></app-field-editor-v2>

    <app-field-editor-v2
      type="content"
      [blockData]="block.variables?.['X2Onp2Name'] ?? ''"
      (handleOnChange)="onChange($event, 'X2Onp2Name')"
      [placeholder]="name2Placeholder"
      [maxLength]="500"
      variable="X2Onp2Name"
      [disabled]="disabled"
    ></app-field-editor-v2>

    <div class="cr-onp-price-fields">
      <app-field-editor-v2
        type="content"
        [blockData]="block.variables?.['X2Onp2OldPrice'] ?? ''"
        (handleOnChange)="onChange($event, 'X2Onp2OldPrice')"
        [placeholder]="oldPrice2Placeholder"
        [maxLength]="25"
        variable="X2Onp2OldPrice"
        [disabled]="disabled"
      ></app-field-editor-v2>

      <app-field-editor-v2
        type="content"
        [blockData]="block.variables?.['X2Onp2NewPrice'] ?? ''"
        (handleOnChange)="onChange($event, 'X2Onp2NewPrice')"
        [placeholder]="newPrice2Placeholder"
        [maxLength]="25"
        variable="X2Onp2NewPrice"
        [disabled]="disabled"
      ></app-field-editor-v2>
    </div>

    <div class="cr-onp-link-field">
      <app-field-editor-v2
        type="action-link"
        [blockData]="block.variables?.['X2Onp2CtaLink'] ?? ''"
        (handleOnChange)="onChange($event, 'X2Onp2CtaLink')"
        [placeholder]="ctaLink2Placeholder"
        [maxLength]="500"
        variable="X2Onp2CtaLink"
        (handleOnSegmentChange)="handleOnSegmentChange($event, 'X2Onp2CtaLinkSegmentRegex')"
        [selectedSegment]="block.variables?.['X2Onp2CtaLinkSegmentRegex'] ?? ''"
        [disabled]="disabled"
      ></app-field-editor-v2>
    </div>

    <app-field-editor-v2
      type="content"
      [blockData]="block.variables?.['X2Onp2CtaText'] ?? ''"
      (handleOnChange)="onChange($event, 'X2Onp2CtaText')"
      [placeholder]="ctaText2Placeholder"
      [maxLength]="30"
      variable="X2Onp2CtaText"
      [disabled]="disabled"
    ></app-field-editor-v2>
  </div>
</div>
